import styled from 'styled-components';

const H3 = styled.h3`
  font-size: 32px;
  margin: 0;
`;

export default H3;
